<div
  class="auth0-callback-error"
  role="alertdialog"
  aria-labelledby="auth0-callback-error-title"
>
  <div class="auth0-callback-error__card">
    <h1 id="auth0-callback-error-title" class="auth0-callback-error__title">
      We couldn't sign you in
    </h1>
    <p class="auth0-callback-error__lead">
      The sign-in service refused this login, so we stopped trying.
    </p>
    <p class="auth0-callback-error__detail-label">
      Message from the sign-in service:
    </p>
    <p class="auth0-callback-error__detail">{{ description() }}</p>
    <p class="auth0-callback-error__hint">
      Try again to sign in with a different method, or sign out to choose
      another account. If it keeps happening, contact the help desk and include
      the message above.
    </p>
    <div class="auth0-callback-error__actions">
      <button
        kendoButton
        type="button"
        themeColor="primary"
        [disabled]="leaving()"
        (click)="tryAgain()"
      >
        Try again
      </button>
      <button
        kendoButton
        type="button"
        fillMode="outline"
        [disabled]="leaving()"
        (click)="signOut()"
      >
        Sign out
      </button>
    </div>
  </div>
</div>
